<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="rowForm">
		<div class="grid mt-0">
			<div class="col-12 py-0">
				<div class="flex align-items-center justify-content-center font-semibold text-lg">
					{{ 'ROW_TYPE' | translate }}
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.ContentType, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.ContentType, 'label')">{{ 'ROW_TYPE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.ContentType, 'borderInput')">
						<p-dropdown [options]="types" formControlName="ContentType" optionLabel="name"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							placeholder="{{ 'ROW_TYPE' | translate }}" optionValue="code" dataKey="code">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentType)" class="flex align-items-center label-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<!-- LANGUAGES TITLE CONTENT -->
		<div class="grid mt-0">
			<div class="col-12">
				<div class="flex align-items-center justify-content-center font-semibold text-lg">
					{{ 'ROW' | translate }}
				</div>
			</div>
		</div>
		<div class="grid">
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentIt, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('it-IT')" width="20">
						{{ 'ITALIANO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentIt, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'ITALIANO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentIt'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentIt)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentEn, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('en-US')" width="20">
						{{ 'INGLESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentEn, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'INGLESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentEn'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentEn)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentEs, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('es-ES')" width="20">
						{{ 'SPAGNOLO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentEs, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'SPAGNOLO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentEs'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentEs)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentDe, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('de-DE')" width="20">
						{{ 'TEDESCO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentDe, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'TEDESCO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentDe'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentDe)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentFr, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('fr-FR')" width="20">
						{{ 'FRANCESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentFr, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'FRANCESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentFr'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentFr)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentNl, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('nl-NL')" width="20">
						{{ 'OLANDESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentNl, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'OLANDESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentNl'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentNl)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentPl, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('pl-PL')" width="20">
						{{ 'POLACCO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentPl, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'POLACCO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentPl'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentPl)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentRu, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('ru-RU')" width="20">
						{{ 'RUSSO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentRu, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'RUSSO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentRu'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentRu)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentSk, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('sk-SK')" width="20">
						{{ 'SLOVENO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentSk, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'SLOVENO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentSk'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentSk)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentHu, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('hu-HU')" width="20">
						{{ 'UNGHERESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentHu, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'UNGHERESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentHu'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentHu)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentPt, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('pt-PT')" width="20">
						{{ 'PORTOGHESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentPt, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'PORTOGHESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentPt'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentPt)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentSv, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('sv-SE')" width="20">
						{{ 'SVEDESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentSv, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'SVEDESE' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentSv'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentSv)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.ContentCs, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('cs-CZ')" width="20">
						{{ 'CECO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.ContentCs, 'borderInput')">
					<textarea id="float-input" placeholder="{{ 'CECO' | translate }}" [rows]="isRowText() ? 10 : 1" cols="180" pInputTextarea [formControlName]="'ContentCs'"></textarea>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.ContentCs)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>
